export default "__VITE_ASSET__D9wA9OHo__"